{
	"language": {
		"aria": "Changer de langue"
	},
	"placeholder": {
		"title": "Votre espace candidat arrive bientôt",
		"body": "Il n'y a rien ici pour le moment. Nous vous enverrons un lien par e-mail dès qu'il sera prêt."
	},
	"not_found": {
		"title": "Page introuvable",
		"body": "Vérifiez le lien que vous avez suivi, ou utilisez le lien reçu dans votre e-mail."
	},
	"error_boundary": {
		"reload": "Recharger la page"
	},
	"login": {
		"loading": "Chargement…",
		"title": "Connectez-vous à votre espace candidat",
		"intro": "Saisissez votre adresse e-mail pour voir vos candidatures.",
		"email_label": "Adresse e-mail",
		"email_placeholder": "vous@exemple.com",
		"submit": "Se connecter",
		"sending": "Envoi…",
		"sent": {
			"title": "Consultez vos e-mails",
			"body": "Si {{email}} correspond à une candidature, un lien de connexion est en route.",
			"retry": "Vous ne l'avez pas reçu ? Vérifiez l'adresse et réessayez"
		},
		"resent": {
			"title": "Nous vous avons envoyé un nouveau lien de connexion",
			"body": "Le lien que vous avez ouvert a expiré. Si votre adresse e-mail correspond à une candidature, un nouveau lien de connexion est en route. Il ouvre la même page.",
			"request_manually": "Vous ne l'avez pas reçu ? Demandez un nouveau lien"
		},
		"request_error": {
			"throttled": "Trop de tentatives. Veuillez patienter une minute et réessayer.",
			"invalid_email": "Veuillez saisir une adresse e-mail valide.",
			"generic": "Une erreur s'est produite. Veuillez réessayer."
		},
		"unknown_organisation": {
			"title": "Page introuvable",
			"body": "Vérifiez le lien que vous avez suivi, ou utilisez le lien reçu dans votre e-mail."
		},
		"error": {
			"title": "Une erreur s'est produite",
			"body": "Nous n'avons pas pu charger cette page. Veuillez réessayer dans un instant."
		}
	},
	"organisations": {
		"title": "Vos candidatures",
		"intro": "Choisissez une entreprise pour voir les candidatures que vous lui avez envoyées.",
		"count_one": "{{count}} candidature",
		"count_other": "{{count}} candidatures",
		"empty": {
			"title": "Aucune candidature pour le moment",
			"body": "Dès que vous postulez auprès d'une entreprise, elle apparaîtra ici."
		},
		"error": "Nous n'avons pas pu charger vos entreprises. Veuillez réessayer dans un instant.",
		"log_out": "Se déconnecter",
		"logging_out": "Déconnexion…"
	},
	"submissions": {
		"title": "Candidatures précédentes",
		"back_to_organisations": "Toutes les entreprises",
		"cv_uploaded": "CV importé",
		"empty": {
			"title": "Aucune candidature pour le moment",
			"body": "Les candidatures que vous envoyez à {{organisation}} apparaîtront ici."
		},
		"error": "Nous n'avons pas pu charger vos candidatures. Veuillez réessayer dans un instant.",
		"log_out": "Se déconnecter",
		"logging_out": "Déconnexion…"
	},
	"profile": {
		"link": {
			"title": "Votre profil",
			"cv_added": "CV ajouté",
			"cv_missing": "Pas encore de CV"
		},
		"back": "Retour à la candidature",
		"context": "{{campaign}} · {{organisation}}",
		"contact_consent": "Vous acceptez d'être contacté(e) au sujet de ce poste.",
		"cv": {
			"title": "CV",
			"upload": {
				"title": "Importer votre CV",
				"drop_hint": "ou glissez-déposez-le ici",
				"constraints": "{{types}}, {{size}} Mo maximum",
				"uploading": "Importation de {{fileName}}…",
				"done": "CV importé",
				"error_type": "Ce type de fichier n'est pas pris en charge. Types acceptés : {{types}}.",
				"error_size": "Ce fichier est trop volumineux. La taille maximale est de {{size}} Mo."
			},
			"remove": {
				"label": "Supprimer {{fileName}}",
				"question": "Supprimer {{fileName}} ?",
				"consequence": "L'employeur ne pourra plus le consulter. Cette action est irréversible.",
				"confirm": "Supprimer le CV",
				"cancel": "Annuler",
				"removing": "Suppression…",
				"error": "Impossible de supprimer votre CV. Veuillez réessayer."
			}
		},
		"work_history": {
			"title": "Expérience professionnelle",
			"description": "Parlez-nous de votre expérience professionnelle pertinente : où vous avez travaillé, ce que vous y faisiez et pendant combien de temps vous y avez travaillé. Vous pouvez ajouter plusieurs emplois s'ils sont pertinents.",
			"placeholder": "Décrivez un emploi que vous avez occupé",
			"input_label": "Détails de l'emploi",
			"save": "Enregistrer",
			"saving": "Enregistrement…",
			"cancel": "Annuler",
			"edit": "Modifier",
			"remove": "Supprimer",
			"add_another": "Ajouter un autre emploi",
			"error_empty": "Écrivez quelque chose avant d'enregistrer.",
			"error_limit": "Vous pouvez ajouter jusqu'à {{max}} emplois.",
			"unsaved_changes": "Vous avez des modifications non enregistrées dans votre expérience professionnelle. Voulez-vous quand même quitter la page et les perdre ?",
			"hints": {
				"label": "Détails de cet emploi",
				"included": "indiqué",
				"missing": "pas encore indiqué"
			}
		},
		"education": {
			"title": "Formation",
			"description": "Parlez-nous de votre formation pertinente : ce que vous avez étudié, où et quand. Diplômes, écoles, cours et certifications comptent tous. Vous pouvez en ajouter plusieurs.",
			"placeholder": "Décrivez un diplôme, une école ou un cours",
			"input_label": "Détails de la formation",
			"save": "Enregistrer",
			"saving": "Enregistrement…",
			"cancel": "Annuler",
			"edit": "Modifier",
			"remove": "Supprimer",
			"add_another": "Ajouter une autre formation",
			"error_empty": "Écrivez quelque chose avant d'enregistrer.",
			"error_limit": "Vous pouvez ajouter jusqu'à {{max}} formations.",
			"unsaved_changes": "Vous avez des modifications non enregistrées dans votre formation. Voulez-vous quand même quitter la page et les perdre ?"
		},
		"licenses": {
			"title": "Permis et certifications",
			"description": "Parlez-nous de vos permis et certifications, comme le permis de conduire, le CACES ou une formation en hygiène alimentaire. Indiquez quand vous l'avez obtenu et quand il expire, le cas échéant. Vous pouvez en ajouter plusieurs.",
			"placeholder": "Décrivez un permis ou une certification",
			"input_label": "Détails du permis",
			"save": "Enregistrer",
			"saving": "Enregistrement…",
			"cancel": "Annuler",
			"edit": "Modifier",
			"remove": "Supprimer",
			"add_another": "Ajouter un autre permis",
			"error_empty": "Écrivez quelque chose avant d'enregistrer.",
			"error_limit": "Vous pouvez ajouter jusqu'à {{max}} permis.",
			"unsaved_changes": "Vous avez des modifications non enregistrées dans vos permis. Voulez-vous quand même quitter la page et les perdre ?"
		}
	},
	"submission": {
		"back": "Retour à mes candidatures",
		"back_short": "Retour",
		"not_found": {
			"title": "Candidature introuvable",
			"body": "Cette candidature n'existe pas, ou elle ne vous appartient pas."
		},
		"result": {
			"heading": "L'écran de confirmation que vous avez vu après avoir postulé"
		},
		"summary": {
			"title": "Récapitulatif de vos réponses",
			"submitted_on": "Vous avez soumis ce formulaire le",
			"submitted_more_than_once": "Vous avez rempli ce formulaire plusieurs fois. Nous fusionnerons automatiquement votre profil ; la candidature ci-dessous est la plus récente."
		}
	}
}
